import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type PartnerState = {
  // quick access fields:
  partnerId: number | null;
  partnerName: string | null;
  currency: string | null;

  // the full config:
  partnerConfig: any | null;

  // setters:
  setPartnerConfig: (config: any | null) => void;
  setPartnerId: (id: number | null) => void;
  setPartnerName: (name: string | null) => void;
  setCurrency: (code: string | null) => void;
};

export const usePartnerStore = create<PartnerState>()(
  persist(
    (set) => ({
      partnerId: null,
      partnerName: null,
      currency: null,
      partnerConfig: null,

      setPartnerConfig: (config) =>
        set(() => ({
          partnerConfig: config,
          partnerId: config?.partnerId ?? null,
          partnerName: config?.partnerName ?? null,
          currency: config?.defaultCurrency ?? null,
        })),

      setPartnerId: (id) => set({ partnerId: id }),
      setPartnerName: (name) => set({ partnerName: name }),
      setCurrency: (code) => set({ currency: code }),
    }),
    {
      name: "partner-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        partnerId: s.partnerId,
        partnerName: s.partnerName,
        currency: s.currency,
        partnerConfig: s.partnerConfig,
      }),
    }
  )
);
